import React, { Component } from "react"
import { Link } from "react-router-dom"

import { getStorageItem, removeStorageItem } from "../helpers/storage"
import { IsSSR } from "../helpers/isSSR"

import { keyToken } from "../config"

class TopHedaer extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.isSSR = IsSSR()
    this.token = null
    if (!this.isSSR) this.token = getStorageItem(keyToken)
    this.doLogout = this.doLogout.bind(this)
  }

  doLogout() {
    if (!this.isSSR)
      removeStorageItem(keyToken).then((r) => console.log("remove token"))
    this.refreshPage()
  }

  refreshPage() {
    if (!this.isSSR) window.location.reload()
  }

  render() {
    const { loading, datas } = this.props

    if (loading) return null

    const renderAds =
      datas && datas["TopBanner"] ? (
        <div style={{ height: '100%' }}>
          {datas["TopBanner"].type == "media" &&
            datas["TopBanner"].media &&
            datas["TopBanner"].media.media_type === "image" && (
              <a
                target="_blank"
                href={
                  datas["TopBanner"].url !== "" ? datas["TopBanner"].url : "#"
                }
              >
                <img
                  src={datas["TopBanner"] ? datas["TopBanner"].media.url : ""}
                  style={{
                    width: "100%",
                    maxHeight: 100,
                    objectFit: "contain"
                  }}
                />
              </a>
            )}
          {datas["TopBanner"].type == "media" &&
            datas["TopBanner"].media &&
            datas["TopBanner"].media.media_type === "video" && (
              <video
                width="100%"
                style={{ height: 105 }}
                controls={false}
                autoPlay
                loop
              >
                <source
                  src={datas["TopBanner"].media.url}
                  type={datas["TopBanner"].media.file_type}
                />
                Your browser does not support the video tag.
              </video>
            )}
          {datas["TopBanner"].type == "adsense" &&
            datas["TopBanner"].adsense && (
              <p
                dangerouslySetInnerHTML={{ __html: datas["TopBanner"].adsense }}
              />
            )}
        </div>
      ) : null

    return (
      <div className="container topbar-ivoox-container">
        <div className="flex-parent">
          <div className="flex-child row align-items-center py-4" id="topbar-ivoox" style={{  display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: 32, flexWrap: 'wrap' }}>
            <div className="d-flex align-items-center">
              <Link
                onClick={this.props.onHomeClick}
                to="/"
                className="logo"
                id="logo-ivoox"
                style={{ display: "inline-flex", alignItems: "center" }}
              >
                <img
                  className="logo__img"
                  alt="logo ivoox"
                  src={"/assets/img/logo.png"}
                  style={{ height: 40, width: "auto", objectFit: "contain" }}
                />
              </Link>
            </div>

            <div className="text-center" style={{ flex: 1 }}>
              {renderAds}
            </div>

            <div
              className="text-right"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 10,
                flexWrap: "wrap"
              }}
            >
              {this.token !== null ? (
                <Link
                  to="/admin/dashboard"
                  style={{
                    fontSize: 12,
                    fontWeight: 700,
                    color: "#1f1f1f",
                    textTransform: "uppercase"
                  }}
                >
                  MY DASHBOARD
                </Link>
              ) : (
                <Link
                  to="/register"
                  style={{
                    fontSize: 12,
                    fontWeight: 700,
                    background: "#d72626",
                    color: "#fff",
                    padding: "10px 18px",
                    borderRadius: 4,
                    textTransform: "uppercase",
                    display: "inline-block"
                  }}
                >
                  JOIN NOW
                </Link>
              )}

              {this.token !== null ? (
                <a
                  href="#"
                  onClick={this.doLogout}
                  style={{
                    fontSize: 12,
                    fontWeight: 700,
                    color: "#1f1f1f",
                    textTransform: "uppercase"
                  }}
                >
                  LOGOUT
                </a>
              ) : (
                <Link
                  to="/auth?page=article"
                  style={{
                    fontSize: 12,
                    fontWeight: 700,
                    color: "#1f1f1f",
                    padding: "10px 18px",
                    border: "1px solid #d7d7d7",
                    borderRadius: 4,
                    textTransform: "uppercase",
                    display: "inline-block"
                  }}
                >
                  SIGN IN
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default TopHedaer
